//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../axios-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @return Success
 */
export function additionalFeesGET(config?: AxiosRequestConfig | undefined): Promise<Types.GetAllAdditionalFeeTypesQueryResult> {
    let url_ = getBaseUrl() + "/additional-fees";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAdditionalFeesGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigAdditionalFeesGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAdditionalFeesGET(_response);
    });
}

function processAdditionalFeesGET(response: AxiosResponse): Promise<Types.GetAllAdditionalFeeTypesQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetAllAdditionalFeeTypesQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetAllAdditionalFeeTypesQueryResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetAllAdditionalFeeTypesQueryResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function authenticationUserExchangeMagicTokenPOST(body?: Types.GenerateAuthenticationUserJwtFromMagicTokenCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GenerateAuthenticationUserJwtFromMagicTokenCommandResult> {
    let url_ = getBaseUrl() + "/authentication-user/exchange-magic-token";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigAuthenticationUserExchangeMagicTokenPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigAuthenticationUserExchangeMagicTokenPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAuthenticationUserExchangeMagicTokenPOST(_response);
    });
}

function processAuthenticationUserExchangeMagicTokenPOST(response: AxiosResponse): Promise<Types.GenerateAuthenticationUserJwtFromMagicTokenCommandResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GenerateAuthenticationUserJwtFromMagicTokenCommandResult.fromJS(resultData200);
        return Promise.resolve<Types.GenerateAuthenticationUserJwtFromMagicTokenCommandResult>(result200);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = Types.ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GenerateAuthenticationUserJwtFromMagicTokenCommandResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function authenticationUserRequestMagicLinkPOST(body?: Types.RequestMagicLinkByBookingGuidCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/authentication-user/request-magic-link";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigAuthenticationUserRequestMagicLinkPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigAuthenticationUserRequestMagicLinkPOST?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAuthenticationUserRequestMagicLinkPOST(_response);
    });
}

function processAuthenticationUserRequestMagicLinkPOST(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = Types.ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param search (optional) 
 * @param markets (optional) 
 * @param ownerGuid (optional) 
 * @param skipperGuid (optional) 
 * @param sortBy (optional) 
 * @param descending (optional) 
 * @return Success
 */
export function boatsGET(pageNumber?: number | undefined, pageSize?: number | undefined, search?: string | undefined, markets?: string[] | undefined, ownerGuid?: string | undefined, skipperGuid?: string | undefined, sortBy?: Types.BoatSortOptions | undefined, descending?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = getBaseUrl() + "/boats?";
    if (pageNumber === null)
        throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
        url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (search === null)
        throw new Error("The parameter 'search' cannot be null.");
    else if (search !== undefined)
        url_ += "Search=" + encodeURIComponent("" + search) + "&";
    if (markets === null)
        throw new Error("The parameter 'markets' cannot be null.");
    else if (markets !== undefined)
        markets && markets.forEach(item => { url_ += "Markets=" + encodeURIComponent("" + item) + "&"; });
    if (ownerGuid === null)
        throw new Error("The parameter 'ownerGuid' cannot be null.");
    else if (ownerGuid !== undefined)
        url_ += "OwnerGuid=" + encodeURIComponent("" + ownerGuid) + "&";
    if (skipperGuid === null)
        throw new Error("The parameter 'skipperGuid' cannot be null.");
    else if (skipperGuid !== undefined)
        url_ += "SkipperGuid=" + encodeURIComponent("" + skipperGuid) + "&";
    if (sortBy === null)
        throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (descending === null)
        throw new Error("The parameter 'descending' cannot be null.");
    else if (descending !== undefined)
        url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigBoatsGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigBoatsGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processBoatsGET(_response);
    });
}

function processBoatsGET(response: AxiosResponse): Promise<Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
        return Promise.resolve<Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
}

/**
 * @param guidQuery (optional) 
 * @return Success
 */
export function boatsGuidGET(guidPath: string, guidQuery?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetBoatQueryResult> {
    let url_ = getBaseUrl() + "/boats/{guid}?";
    if (guidPath === undefined || guidPath === null)
      throw new Error("The parameter 'guidPath' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guidPath));
    if (guidQuery === null)
        throw new Error("The parameter 'guidQuery' cannot be null.");
    else if (guidQuery !== undefined)
        url_ += "guid=" + encodeURIComponent("" + guidQuery) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigBoatsGuidGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigBoatsGuidGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processBoatsGuidGET(_response);
    });
}

function processBoatsGuidGET(response: AxiosResponse): Promise<Types.GetBoatQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetBoatQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetBoatQueryResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetBoatQueryResult>(null as any);
}

/**
 * @return Success
 */
export function boatsGuidGalleryGET(guid: string, config?: AxiosRequestConfig | undefined): Promise<Types.GetBoatGalleryQueryResult> {
    let url_ = getBaseUrl() + "/boats/{guid}/gallery";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigBoatsGuidGalleryGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigBoatsGuidGalleryGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processBoatsGuidGalleryGET(_response);
    });
}

function processBoatsGuidGalleryGET(response: AxiosResponse): Promise<Types.GetBoatGalleryQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetBoatGalleryQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetBoatGalleryQueryResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetBoatGalleryQueryResult>(null as any);
}

/**
 * @return Success
 */
export function boatsVisibleInCalendarGET(config?: AxiosRequestConfig | undefined): Promise<Types.GetVisibleBoatsInCalendarQueryResult> {
    let url_ = getBaseUrl() + "/boats/visible-in-calendar";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigBoatsVisibleInCalendarGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigBoatsVisibleInCalendarGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processBoatsVisibleInCalendarGET(_response);
    });
}

function processBoatsVisibleInCalendarGET(response: AxiosResponse): Promise<Types.GetVisibleBoatsInCalendarQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetVisibleBoatsInCalendarQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetVisibleBoatsInCalendarQueryResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetVisibleBoatsInCalendarQueryResult>(null as any);
}

/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @return Success
 */
export function boatsByLocationLocationguidGET(locationGuid: string, pageNumber?: number | undefined, pageSize?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = getBaseUrl() + "/boats/by-location/{locationGuid}?";
    if (locationGuid === undefined || locationGuid === null)
      throw new Error("The parameter 'locationGuid' must be defined.");
    url_ = url_.replace("{locationGuid}", encodeURIComponent("" + locationGuid));
    if (pageNumber === null)
        throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
        url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigBoatsByLocationLocationguidGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigBoatsByLocationLocationguidGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processBoatsByLocationLocationguidGET(_response);
    });
}

function processBoatsByLocationLocationguidGET(response: AxiosResponse): Promise<Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
        return Promise.resolve<Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
}

/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param markets (optional) 
 * @return Success
 */
export function boatsPublishedGET(pageNumber?: number | undefined, pageSize?: number | undefined, markets?: string[] | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = getBaseUrl() + "/boats/published?";
    if (pageNumber === null)
        throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
        url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (markets === null)
        throw new Error("The parameter 'markets' cannot be null.");
    else if (markets !== undefined)
        markets && markets.forEach(item => { url_ += "Markets=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigBoatsPublishedGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigBoatsPublishedGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processBoatsPublishedGET(_response);
    });
}

function processBoatsPublishedGET(response: AxiosResponse): Promise<Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
        return Promise.resolve<Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function bookingsPOST(body?: Types.CreateMarketplaceBookingCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/bookings";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigBookingsPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigBookingsPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processBookingsPOST(_response);
    });
}

function processBookingsPOST(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param dateFrom (optional) 
 * @param dateTo (optional) 
 * @return Success
 */
export function bookingsByCreationDateRangeGET(pageNumber?: number | undefined, pageSize?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = getBaseUrl() + "/bookings/by-creation-date-range?";
    if (pageNumber === null)
        throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
        url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (dateFrom === null)
        throw new Error("The parameter 'dateFrom' cannot be null.");
    else if (dateFrom !== undefined)
        url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + Types.formatDate(dateFrom) : "") + "&";
    if (dateTo === null)
        throw new Error("The parameter 'dateTo' cannot be null.");
    else if (dateTo !== undefined)
        url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + Types.formatDate(dateTo) : "") + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigBookingsByCreationDateRangeGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigBookingsByCreationDateRangeGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processBookingsByCreationDateRangeGET(_response);
    });
}

function processBookingsByCreationDateRangeGET(response: AxiosResponse): Promise<Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
        return Promise.resolve<Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
}

/**
 * @return Success
 */
export function bookingsGuidGET(guid: string, config?: AxiosRequestConfig | undefined): Promise<Types.GetBookingQueryResult> {
    let url_ = getBaseUrl() + "/bookings/{guid}";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigBookingsGuidGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigBookingsGuidGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processBookingsGuidGET(_response);
    });
}

function processBookingsGuidGET(response: AxiosResponse): Promise<Types.GetBookingQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetBookingQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetBookingQueryResult>(result200);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = Types.ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = Types.ProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetBookingQueryResult>(null as any);
}

/**
 * @return Success
 */
export function bookingsGuidCustomerGET(guid: string, config?: AxiosRequestConfig | undefined): Promise<Types.GetBookingCustomerQueryResult> {
    let url_ = getBaseUrl() + "/bookings/{guid}/customer";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigBookingsGuidCustomerGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigBookingsGuidCustomerGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processBookingsGuidCustomerGET(_response);
    });
}

function processBookingsGuidCustomerGET(response: AxiosResponse): Promise<Types.GetBookingCustomerQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetBookingCustomerQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetBookingCustomerQueryResult>(result200);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = Types.ProblemDetails.fromJS(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = Types.ProblemDetails.fromJS(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetBookingCustomerQueryResult>(null as any);
}

/**
 * @param body (optional) 
 * @return No Content
 */
export function campaignsVisitPOST(body?: Types.AddCampaignVisitCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/campaigns/visit";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCampaignsVisitPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCampaignsVisitPOST?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCampaignsVisitPOST(_response);
    });
}

function processCampaignsVisitPOST(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function customersPOST(body?: Types.GetOrCreateCustomerByEmailCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/customers";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCustomersPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCustomersPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCustomersPOST(_response);
    });
}

function processCustomersPOST(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * @return Success
 */
export function customersCustomerguidWorldpayCustomerIdGET(customerGuid: string, config?: AxiosRequestConfig | undefined): Promise<Types.GetWorldPayCustomerIdQueryResult> {
    let url_ = getBaseUrl() + "/customers/{customerGuid}/worldpay-customer-id";
    if (customerGuid === undefined || customerGuid === null)
      throw new Error("The parameter 'customerGuid' must be defined.");
    url_ = url_.replace("{customerGuid}", encodeURIComponent("" + customerGuid));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCustomersCustomerguidWorldpayCustomerIdGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigCustomersCustomerguidWorldpayCustomerIdGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCustomersCustomerguidWorldpayCustomerIdGET(_response);
    });
}

function processCustomersCustomerguidWorldpayCustomerIdGET(response: AxiosResponse): Promise<Types.GetWorldPayCustomerIdQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetWorldPayCustomerIdQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetWorldPayCustomerIdQueryResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetWorldPayCustomerIdQueryResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function formLeadsSubmitPOST(body?: Types.SubmitFormLeadCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/form-leads/submit";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigFormLeadsSubmitPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigFormLeadsSubmitPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processFormLeadsSubmitPOST(_response);
    });
}

function processFormLeadsSubmitPOST(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * @return Success
 */
export function listingsGuidGET(guid: string, config?: AxiosRequestConfig | undefined): Promise<Types.GetMarketplaceListingQueryResult> {
    let url_ = getBaseUrl() + "/listings/{guid}";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigListingsGuidGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigListingsGuidGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processListingsGuidGET(_response);
    });
}

function processListingsGuidGET(response: AxiosResponse): Promise<Types.GetMarketplaceListingQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetMarketplaceListingQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetMarketplaceListingQueryResult>(result200);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetMarketplaceListingQueryResult>(null as any);
}

/**
 * @param from (optional) 
 * @param to (optional) 
 * @return Success
 */
export function listingsGuidCalendarDaysGET(guid: string, from?: Date | undefined, to?: Date | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetMarketplaceCalendarDaysQueryResult[]> {
    let url_ = getBaseUrl() + "/listings/{guid}/calendar-days?";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
    if (from === null)
        throw new Error("The parameter 'from' cannot be null.");
    else if (from !== undefined)
        url_ += "from=" + encodeURIComponent(from ? "" + Types.formatDate(from) : "") + "&";
    if (to === null)
        throw new Error("The parameter 'to' cannot be null.");
    else if (to !== undefined)
        url_ += "to=" + encodeURIComponent(to ? "" + Types.formatDate(to) : "") + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigListingsGuidCalendarDaysGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigListingsGuidCalendarDaysGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processListingsGuidCalendarDaysGET(_response);
    });
}

function processListingsGuidCalendarDaysGET(response: AxiosResponse): Promise<Types.GetMarketplaceCalendarDaysQueryResult[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.GetMarketplaceCalendarDaysQueryResult.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.GetMarketplaceCalendarDaysQueryResult[]>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetMarketplaceCalendarDaysQueryResult[]>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function listingsAvailablePOST(body?: Types.GetMarketplaceAvailableListingQuery | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetMarketplaceAvailableListingQueryResult> {
    let url_ = getBaseUrl() + "/listings/available";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigListingsAvailablePOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigListingsAvailablePOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processListingsAvailablePOST(_response);
    });
}

function processListingsAvailablePOST(response: AxiosResponse): Promise<Types.GetMarketplaceAvailableListingQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetMarketplaceAvailableListingQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetMarketplaceAvailableListingQueryResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetMarketplaceAvailableListingQueryResult>(null as any);
}

/**
 * @param date (optional) 
 * @return Success
 */
export function listingsGuidCalendarDayPricingsGET(guid: string, date?: Date | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetMarketplaceCalendarDayPricingsQueryResult> {
    let url_ = getBaseUrl() + "/listings/{guid}/calendar-day-pricings?";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
    if (date === null)
        throw new Error("The parameter 'date' cannot be null.");
    else if (date !== undefined)
        url_ += "date=" + encodeURIComponent(date ? "" + Types.formatDate(date) : "") + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigListingsGuidCalendarDayPricingsGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigListingsGuidCalendarDayPricingsGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processListingsGuidCalendarDayPricingsGET(_response);
    });
}

function processListingsGuidCalendarDayPricingsGET(response: AxiosResponse): Promise<Types.GetMarketplaceCalendarDayPricingsQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetMarketplaceCalendarDayPricingsQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetMarketplaceCalendarDayPricingsQueryResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetMarketplaceCalendarDayPricingsQueryResult>(null as any);
}

/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param date (optional) 
 * @param marketTitle (optional) 
 * @param boatGuids (optional) 
 * @return Success
 */
export function listingsAvailableListingsDetailsGET(pageNumber?: number | undefined, pageSize?: number | undefined, date?: Date | undefined, marketTitle?: string | undefined, boatGuids?: string[] | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = getBaseUrl() + "/listings/available-listings-details?";
    if (pageNumber === null)
        throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
        url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null)
        throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
        url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (date === null)
        throw new Error("The parameter 'date' cannot be null.");
    else if (date !== undefined)
        url_ += "Date=" + encodeURIComponent(date ? "" + Types.formatDate(date) : "") + "&";
    if (marketTitle === null)
        throw new Error("The parameter 'marketTitle' cannot be null.");
    else if (marketTitle !== undefined)
        url_ += "MarketTitle=" + encodeURIComponent("" + marketTitle) + "&";
    if (boatGuids === null)
        throw new Error("The parameter 'boatGuids' cannot be null.");
    else if (boatGuids !== undefined)
        boatGuids && boatGuids.forEach(item => { url_ += "BoatGuids=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigListingsAvailableListingsDetailsGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigListingsAvailableListingsDetailsGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processListingsAvailableListingsDetailsGET(_response);
    });
}

function processListingsAvailableListingsDetailsGET(response: AxiosResponse): Promise<Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
        return Promise.resolve<Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>(null as any);
}

/**
 * @return Success
 */
export function ownersGuidGET(guid: string, config?: AxiosRequestConfig | undefined): Promise<Types.GetOwnerQueryResult> {
    let url_ = getBaseUrl() + "/owners/{guid}";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigOwnersGuidGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigOwnersGuidGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processOwnersGuidGET(_response);
    });
}

function processOwnersGuidGET(response: AxiosResponse): Promise<Types.GetOwnerQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetOwnerQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetOwnerQueryResult>(result200);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetOwnerQueryResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 * @deprecated
 */
export function paymentsCreatePaymentIntentPOST(body?: Types.CreateBookingPaymentIntentCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.CreatePaymentIntentCommandResult> {
    let url_ = getBaseUrl() + "/payments/create-payment-intent";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsCreatePaymentIntentPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPaymentsCreatePaymentIntentPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsCreatePaymentIntentPOST(_response);
    });
}

function processPaymentsCreatePaymentIntentPOST(response: AxiosResponse): Promise<Types.CreatePaymentIntentCommandResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.CreatePaymentIntentCommandResult.fromJS(resultData200);
        return Promise.resolve<Types.CreatePaymentIntentCommandResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CreatePaymentIntentCommandResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function paymentsAuthorize_NetCreatePaymentPOST(body?: Types.ChargeBookingAuthorizeNetPaymentCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ChargeBookingAuthorizeNetPaymentCommandResult> {
    let url_ = getBaseUrl() + "/payments/authorize.net/create-payment";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsAuthorize_NetCreatePaymentPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPaymentsAuthorize_NetCreatePaymentPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsAuthorize_NetCreatePaymentPOST(_response);
    });
}

function processPaymentsAuthorize_NetCreatePaymentPOST(response: AxiosResponse): Promise<Types.ChargeBookingAuthorizeNetPaymentCommandResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ChargeBookingAuthorizeNetPaymentCommandResult.fromJS(resultData200);
        return Promise.resolve<Types.ChargeBookingAuthorizeNetPaymentCommandResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ChargeBookingAuthorizeNetPaymentCommandResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function paymentsAuthorize_NetCheckoutSessionPaymentProcessPOST(body?: Types.ProcessAuthorizeNetCheckoutSessionPaymentCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ProcessAuthorizeNetCheckoutSessionPaymentCommandResult> {
    let url_ = getBaseUrl() + "/payments/authorize.net/checkout-session-payment/process";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOST(_response);
    });
}

function processPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOST(response: AxiosResponse): Promise<Types.ProcessAuthorizeNetCheckoutSessionPaymentCommandResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ProcessAuthorizeNetCheckoutSessionPaymentCommandResult.fromJS(resultData200);
        return Promise.resolve<Types.ProcessAuthorizeNetCheckoutSessionPaymentCommandResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ProcessAuthorizeNetCheckoutSessionPaymentCommandResult>(null as any);
}

/**
 * @return Success
 */
export function paymentsGuidGET(guid: string, config?: AxiosRequestConfig | undefined): Promise<Types.GetPaymentQueryResult> {
    let url_ = getBaseUrl() + "/payments/{guid}";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsGuidGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPaymentsGuidGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsGuidGET(_response);
    });
}

function processPaymentsGuidGET(response: AxiosResponse): Promise<Types.GetPaymentQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetPaymentQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetPaymentQueryResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetPaymentQueryResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function paymentsCreatePaymentSessionPOST(body?: Types.CreateBookingStripeCheckoutSessionCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.CreateStripeCheckoutSessionCommandResult> {
    let url_ = getBaseUrl() + "/payments/create-payment-session";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsCreatePaymentSessionPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPaymentsCreatePaymentSessionPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsCreatePaymentSessionPOST(_response);
    });
}

function processPaymentsCreatePaymentSessionPOST(response: AxiosResponse): Promise<Types.CreateStripeCheckoutSessionCommandResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.CreateStripeCheckoutSessionCommandResult.fromJS(resultData200);
        return Promise.resolve<Types.CreateStripeCheckoutSessionCommandResult>(result200);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CreateStripeCheckoutSessionCommandResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function paymentsCustomerDashboardCreatePaymentSessionPOST(body?: Types.CreateCustomerDashboardBookingStripeCheckoutSessionCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.CreateCustomerDashboardBookingStripeCheckoutSessionCommandResult> {
    let url_ = getBaseUrl() + "/payments/customer-dashboard/create-payment-session";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsCustomerDashboardCreatePaymentSessionPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPaymentsCustomerDashboardCreatePaymentSessionPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsCustomerDashboardCreatePaymentSessionPOST(_response);
    });
}

function processPaymentsCustomerDashboardCreatePaymentSessionPOST(response: AxiosResponse): Promise<Types.CreateCustomerDashboardBookingStripeCheckoutSessionCommandResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.CreateCustomerDashboardBookingStripeCheckoutSessionCommandResult.fromJS(resultData200);
        return Promise.resolve<Types.CreateCustomerDashboardBookingStripeCheckoutSessionCommandResult>(result200);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CreateCustomerDashboardBookingStripeCheckoutSessionCommandResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function paymentsAuthorize_NetCheckoutSessionPaymentPOST(body?: Types.CreateBookingAuthorizeNetCheckoutSessionCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/payments/authorize.net/checkout-session-payment";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsAuthorize_NetCheckoutSessionPaymentPOST(_response);
    });
}

function processPaymentsAuthorize_NetCheckoutSessionPaymentPOST(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<string>(result200);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

/**
 * @return Success
 */
export function paymentsAuthorize_NetCheckoutSessionGuidGET(guid: string, config?: AxiosRequestConfig | undefined): Promise<Types.GetAuthorizeNetCheckoutSessionQueryResponse> {
    let url_ = getBaseUrl() + "/payments/authorize.net/checkout-session/{guid}";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsAuthorize_NetCheckoutSessionGuidGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPaymentsAuthorize_NetCheckoutSessionGuidGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsAuthorize_NetCheckoutSessionGuidGET(_response);
    });
}

function processPaymentsAuthorize_NetCheckoutSessionGuidGET(response: AxiosResponse): Promise<Types.GetAuthorizeNetCheckoutSessionQueryResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetAuthorizeNetCheckoutSessionQueryResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetAuthorizeNetCheckoutSessionQueryResponse>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetAuthorizeNetCheckoutSessionQueryResponse>(null as any);
}

/**
 * @param guid (optional) 
 * @return Success
 */
export function paymentsStatusGET(guid?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetPaymentStatusQueryResult> {
    let url_ = getBaseUrl() + "/payments/status?";
    if (guid === null)
        throw new Error("The parameter 'guid' cannot be null.");
    else if (guid !== undefined)
        url_ += "Guid=" + encodeURIComponent("" + guid) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsStatusGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPaymentsStatusGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsStatusGET(_response);
    });
}

function processPaymentsStatusGET(response: AxiosResponse): Promise<Types.GetPaymentStatusQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetPaymentStatusQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetPaymentStatusQueryResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetPaymentStatusQueryResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function paymentsWorldpayCheckoutSessionPaymentPOST(body?: Types.CreateBookingWorldPayCheckoutSessionCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.CreateBookingWorldPayCheckoutSessionCommandResult> {
    let url_ = getBaseUrl() + "/payments/worldpay/checkout-session-payment";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsWorldpayCheckoutSessionPaymentPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPaymentsWorldpayCheckoutSessionPaymentPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsWorldpayCheckoutSessionPaymentPOST(_response);
    });
}

function processPaymentsWorldpayCheckoutSessionPaymentPOST(response: AxiosResponse): Promise<Types.CreateBookingWorldPayCheckoutSessionCommandResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.CreateBookingWorldPayCheckoutSessionCommandResult.fromJS(resultData200);
        return Promise.resolve<Types.CreateBookingWorldPayCheckoutSessionCommandResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CreateBookingWorldPayCheckoutSessionCommandResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function paymentsWorldpayCheckoutSessionPaymentProcessPOST(body?: Types.ProcessWorldPayCheckoutSessionPaymentCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ProcessWorldPayCheckoutSessionPaymentCommandResult> {
    let url_ = getBaseUrl() + "/payments/worldpay/checkout-session-payment/process";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsWorldpayCheckoutSessionPaymentProcessPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPaymentsWorldpayCheckoutSessionPaymentProcessPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsWorldpayCheckoutSessionPaymentProcessPOST(_response);
    });
}

function processPaymentsWorldpayCheckoutSessionPaymentProcessPOST(response: AxiosResponse): Promise<Types.ProcessWorldPayCheckoutSessionPaymentCommandResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ProcessWorldPayCheckoutSessionPaymentCommandResult.fromJS(resultData200);
        return Promise.resolve<Types.ProcessWorldPayCheckoutSessionPaymentCommandResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ProcessWorldPayCheckoutSessionPaymentCommandResult>(null as any);
}

/**
 * @return Success
 */
export function paymentsWorldpayCheckoutSessionGuidGET(guid: string, config?: AxiosRequestConfig | undefined): Promise<Types.GetWorldPayCheckoutSessionQueryResponse> {
    let url_ = getBaseUrl() + "/payments/worldpay/checkout-session/{guid}";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsWorldpayCheckoutSessionGuidGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPaymentsWorldpayCheckoutSessionGuidGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsWorldpayCheckoutSessionGuidGET(_response);
    });
}

function processPaymentsWorldpayCheckoutSessionGuidGET(response: AxiosResponse): Promise<Types.GetWorldPayCheckoutSessionQueryResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetWorldPayCheckoutSessionQueryResponse.fromJS(resultData200);
        return Promise.resolve<Types.GetWorldPayCheckoutSessionQueryResponse>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetWorldPayCheckoutSessionQueryResponse>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function paymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST(body?: Types.CreateCustomerDashboardBookingWorldPayCheckoutSessionCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.CreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult> {
    let url_ = getBaseUrl() + "/payments/customer-dashboard/worldpay/checkout-session-payment";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST(_response);
    });
}

function processPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST(response: AxiosResponse): Promise<Types.CreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.CreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult.fromJS(resultData200);
        return Promise.resolve<Types.CreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult>(null as any);
}

export function paymentsIntent__DebugPOST(paymentIntentId?: string | undefined, paymentIntentEventType?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/payments/intent__debug?";
    if (paymentIntentId === null)
        throw new Error("The parameter 'paymentIntentId' cannot be null.");
    else if (paymentIntentId !== undefined)
        url_ += "paymentIntentId=" + encodeURIComponent("" + paymentIntentId) + "&";
    if (paymentIntentEventType === null)
        throw new Error("The parameter 'paymentIntentEventType' cannot be null.");
    else if (paymentIntentEventType !== undefined)
        url_ += "paymentIntentEventType=" + encodeURIComponent("" + paymentIntentEventType) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsIntent__DebugPOST,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPaymentsIntent__DebugPOST?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsIntent__DebugPOST(_response);
    });
}

function processPaymentsIntent__DebugPOST(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function paymentsCheckoutSession__DebugPOST(sessionId?: string | undefined, amountTotal?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/payments/checkout-session__debug?";
    if (sessionId === null)
        throw new Error("The parameter 'sessionId' cannot be null.");
    else if (sessionId !== undefined)
        url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
    if (amountTotal === null)
        throw new Error("The parameter 'amountTotal' cannot be null.");
    else if (amountTotal !== undefined)
        url_ += "amountTotal=" + encodeURIComponent("" + amountTotal) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPaymentsCheckoutSession__DebugPOST,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPaymentsCheckoutSession__DebugPOST?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPaymentsCheckoutSession__DebugPOST(_response);
    });
}

function processPaymentsCheckoutSession__DebugPOST(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @return Success
 */
export function platformAccountPaymentGatewayGET(config?: AxiosRequestConfig | undefined): Promise<Types.GetPlatformAccountPaymentGatewayQueryResult> {
    let url_ = getBaseUrl() + "/platform-account/payment-gateway";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPlatformAccountPaymentGatewayGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPlatformAccountPaymentGatewayGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPlatformAccountPaymentGatewayGET(_response);
    });
}

function processPlatformAccountPaymentGatewayGET(response: AxiosResponse): Promise<Types.GetPlatformAccountPaymentGatewayQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetPlatformAccountPaymentGatewayQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetPlatformAccountPaymentGatewayQueryResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetPlatformAccountPaymentGatewayQueryResult>(null as any);
}

/**
 * @param pricingGuid (optional) 
 * @param passengers (optional) 
 * @param promoCodeRequest_PromoCode (optional) 
 * @param promoCodeRequest_StartDateTime (optional) 
 * @param campaignCodeRequest_Code (optional) 
 * @param campaignCodeRequest_StartDateTime (optional) 
 * @return Success
 */
export function pricingsCalculateGET(pricingGuid?: string | undefined, passengers?: number | undefined, promoCodeRequest_PromoCode?: string | undefined, promoCodeRequest_StartDateTime?: Date | undefined, campaignCodeRequest_Code?: string | undefined, campaignCodeRequest_StartDateTime?: Date | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.GetMarketplaceCalculatedPriceQueryResult> {
    let url_ = getBaseUrl() + "/pricings/calculate?";
    if (pricingGuid === null)
        throw new Error("The parameter 'pricingGuid' cannot be null.");
    else if (pricingGuid !== undefined)
        url_ += "PricingGuid=" + encodeURIComponent("" + pricingGuid) + "&";
    if (passengers === null)
        throw new Error("The parameter 'passengers' cannot be null.");
    else if (passengers !== undefined)
        url_ += "Passengers=" + encodeURIComponent("" + passengers) + "&";
    if (promoCodeRequest_PromoCode === null)
        throw new Error("The parameter 'promoCodeRequest_PromoCode' cannot be null.");
    else if (promoCodeRequest_PromoCode !== undefined)
        url_ += "PromoCodeRequest.PromoCode=" + encodeURIComponent("" + promoCodeRequest_PromoCode) + "&";
    if (promoCodeRequest_StartDateTime === null)
        throw new Error("The parameter 'promoCodeRequest_StartDateTime' cannot be null.");
    else if (promoCodeRequest_StartDateTime !== undefined)
        url_ += "PromoCodeRequest.StartDateTime=" + encodeURIComponent(promoCodeRequest_StartDateTime ? "" + promoCodeRequest_StartDateTime.toISOString() : "") + "&";
    if (campaignCodeRequest_Code === null)
        throw new Error("The parameter 'campaignCodeRequest_Code' cannot be null.");
    else if (campaignCodeRequest_Code !== undefined)
        url_ += "CampaignCodeRequest.Code=" + encodeURIComponent("" + campaignCodeRequest_Code) + "&";
    if (campaignCodeRequest_StartDateTime === null)
        throw new Error("The parameter 'campaignCodeRequest_StartDateTime' cannot be null.");
    else if (campaignCodeRequest_StartDateTime !== undefined)
        url_ += "CampaignCodeRequest.StartDateTime=" + encodeURIComponent(campaignCodeRequest_StartDateTime ? "" + campaignCodeRequest_StartDateTime.toISOString() : "") + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPricingsCalculateGET,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPricingsCalculateGET?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPricingsCalculateGET(_response);
    });
}

function processPricingsCalculateGET(response: AxiosResponse): Promise<Types.GetMarketplaceCalculatedPriceQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GetMarketplaceCalculatedPriceQueryResult.fromJS(resultData200);
        return Promise.resolve<Types.GetMarketplaceCalculatedPriceQueryResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GetMarketplaceCalculatedPriceQueryResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function pricingsGuidPromoCodeValidationPOST(guid: string, body?: Types.ValidateOrderingPromoCodeCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ValidatePromoCodeResult> {
    let url_ = getBaseUrl() + "/pricings/{guid}/promo-code/validation";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPricingsGuidPromoCodeValidationPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPricingsGuidPromoCodeValidationPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPricingsGuidPromoCodeValidationPOST(_response);
    });
}

function processPricingsGuidPromoCodeValidationPOST(response: AxiosResponse): Promise<Types.ValidatePromoCodeResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ValidatePromoCodeResult.fromJS(resultData200);
        return Promise.resolve<Types.ValidatePromoCodeResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ValidatePromoCodeResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function pricingsGuidCampaignValidationPOST(guid: string, body?: Types.ValidateCampaignCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ValidateCampaignResult> {
    let url_ = getBaseUrl() + "/pricings/{guid}/campaign/validation";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPricingsGuidCampaignValidationPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPricingsGuidCampaignValidationPOST?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPricingsGuidCampaignValidationPOST(_response);
    });
}

function processPricingsGuidCampaignValidationPOST(response: AxiosResponse): Promise<Types.ValidateCampaignResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ValidateCampaignResult.fromJS(resultData200);
        return Promise.resolve<Types.ValidateCampaignResult>(result200);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ValidateCampaignResult>(null as any);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function pricingsGuidCampaignValidationByCustomerEmailPOST(guid: string, body?: Types.ValidateCampaignByEmailCommand | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/pricings/{guid}/campaign/validation/by-customer-email";
    if (guid === undefined || guid === null)
      throw new Error("The parameter 'guid' must be defined.");
    url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPricingsGuidCampaignValidationByCustomerEmailPOST,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPricingsGuidCampaignValidationByCustomerEmailPOST?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPricingsGuidCampaignValidationByCustomerEmailPOST(_response);
    });
}

function processPricingsGuidCampaignValidationByCustomerEmailPOST(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @return No Content
 */
export function testTestSentryPUT(config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/test/test-sentry";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigTestTestSentryPUT,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigTestTestSentryPUT?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTestTestSentryPUT(_response);
    });
}

function processTestTestSentryPUT(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ProblemDetails.fromJS(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = Types.ProblemDetails.fromJS(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigAdditionalFeesGET: Partial<AxiosRequestConfig> | null;
export function getAdditionalFeesGETRequestConfig() {
  return _requestConfigAdditionalFeesGET;
}
export function setAdditionalFeesGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAdditionalFeesGET = value;
}
export function patchAdditionalFeesGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAdditionalFeesGET = patch(_requestConfigAdditionalFeesGET ?? {});
}

let _requestConfigAuthenticationUserExchangeMagicTokenPOST: Partial<AxiosRequestConfig> | null;
export function getAuthenticationUserExchangeMagicTokenPOSTRequestConfig() {
  return _requestConfigAuthenticationUserExchangeMagicTokenPOST;
}
export function setAuthenticationUserExchangeMagicTokenPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAuthenticationUserExchangeMagicTokenPOST = value;
}
export function patchAuthenticationUserExchangeMagicTokenPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAuthenticationUserExchangeMagicTokenPOST = patch(_requestConfigAuthenticationUserExchangeMagicTokenPOST ?? {});
}

let _requestConfigAuthenticationUserRequestMagicLinkPOST: Partial<AxiosRequestConfig> | null;
export function getAuthenticationUserRequestMagicLinkPOSTRequestConfig() {
  return _requestConfigAuthenticationUserRequestMagicLinkPOST;
}
export function setAuthenticationUserRequestMagicLinkPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAuthenticationUserRequestMagicLinkPOST = value;
}
export function patchAuthenticationUserRequestMagicLinkPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAuthenticationUserRequestMagicLinkPOST = patch(_requestConfigAuthenticationUserRequestMagicLinkPOST ?? {});
}

let _requestConfigBoatsGET: Partial<AxiosRequestConfig> | null;
export function getBoatsGETRequestConfig() {
  return _requestConfigBoatsGET;
}
export function setBoatsGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigBoatsGET = value;
}
export function patchBoatsGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigBoatsGET = patch(_requestConfigBoatsGET ?? {});
}

let _requestConfigBoatsGuidGET: Partial<AxiosRequestConfig> | null;
export function getBoatsGuidGETRequestConfig() {
  return _requestConfigBoatsGuidGET;
}
export function setBoatsGuidGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigBoatsGuidGET = value;
}
export function patchBoatsGuidGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigBoatsGuidGET = patch(_requestConfigBoatsGuidGET ?? {});
}

let _requestConfigBoatsGuidGalleryGET: Partial<AxiosRequestConfig> | null;
export function getBoatsGuidGalleryGETRequestConfig() {
  return _requestConfigBoatsGuidGalleryGET;
}
export function setBoatsGuidGalleryGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigBoatsGuidGalleryGET = value;
}
export function patchBoatsGuidGalleryGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigBoatsGuidGalleryGET = patch(_requestConfigBoatsGuidGalleryGET ?? {});
}

let _requestConfigBoatsVisibleInCalendarGET: Partial<AxiosRequestConfig> | null;
export function getBoatsVisibleInCalendarGETRequestConfig() {
  return _requestConfigBoatsVisibleInCalendarGET;
}
export function setBoatsVisibleInCalendarGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigBoatsVisibleInCalendarGET = value;
}
export function patchBoatsVisibleInCalendarGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigBoatsVisibleInCalendarGET = patch(_requestConfigBoatsVisibleInCalendarGET ?? {});
}

let _requestConfigBoatsByLocationLocationguidGET: Partial<AxiosRequestConfig> | null;
export function getBoatsByLocationLocationguidGETRequestConfig() {
  return _requestConfigBoatsByLocationLocationguidGET;
}
export function setBoatsByLocationLocationguidGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigBoatsByLocationLocationguidGET = value;
}
export function patchBoatsByLocationLocationguidGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigBoatsByLocationLocationguidGET = patch(_requestConfigBoatsByLocationLocationguidGET ?? {});
}

let _requestConfigBoatsPublishedGET: Partial<AxiosRequestConfig> | null;
export function getBoatsPublishedGETRequestConfig() {
  return _requestConfigBoatsPublishedGET;
}
export function setBoatsPublishedGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigBoatsPublishedGET = value;
}
export function patchBoatsPublishedGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigBoatsPublishedGET = patch(_requestConfigBoatsPublishedGET ?? {});
}

let _requestConfigBookingsPOST: Partial<AxiosRequestConfig> | null;
export function getBookingsPOSTRequestConfig() {
  return _requestConfigBookingsPOST;
}
export function setBookingsPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigBookingsPOST = value;
}
export function patchBookingsPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigBookingsPOST = patch(_requestConfigBookingsPOST ?? {});
}

let _requestConfigBookingsByCreationDateRangeGET: Partial<AxiosRequestConfig> | null;
export function getBookingsByCreationDateRangeGETRequestConfig() {
  return _requestConfigBookingsByCreationDateRangeGET;
}
export function setBookingsByCreationDateRangeGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigBookingsByCreationDateRangeGET = value;
}
export function patchBookingsByCreationDateRangeGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigBookingsByCreationDateRangeGET = patch(_requestConfigBookingsByCreationDateRangeGET ?? {});
}

let _requestConfigBookingsGuidGET: Partial<AxiosRequestConfig> | null;
export function getBookingsGuidGETRequestConfig() {
  return _requestConfigBookingsGuidGET;
}
export function setBookingsGuidGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigBookingsGuidGET = value;
}
export function patchBookingsGuidGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigBookingsGuidGET = patch(_requestConfigBookingsGuidGET ?? {});
}

let _requestConfigBookingsGuidCustomerGET: Partial<AxiosRequestConfig> | null;
export function getBookingsGuidCustomerGETRequestConfig() {
  return _requestConfigBookingsGuidCustomerGET;
}
export function setBookingsGuidCustomerGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigBookingsGuidCustomerGET = value;
}
export function patchBookingsGuidCustomerGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigBookingsGuidCustomerGET = patch(_requestConfigBookingsGuidCustomerGET ?? {});
}

let _requestConfigCampaignsVisitPOST: Partial<AxiosRequestConfig> | null;
export function getCampaignsVisitPOSTRequestConfig() {
  return _requestConfigCampaignsVisitPOST;
}
export function setCampaignsVisitPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCampaignsVisitPOST = value;
}
export function patchCampaignsVisitPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCampaignsVisitPOST = patch(_requestConfigCampaignsVisitPOST ?? {});
}

let _requestConfigCustomersPOST: Partial<AxiosRequestConfig> | null;
export function getCustomersPOSTRequestConfig() {
  return _requestConfigCustomersPOST;
}
export function setCustomersPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCustomersPOST = value;
}
export function patchCustomersPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCustomersPOST = patch(_requestConfigCustomersPOST ?? {});
}

let _requestConfigCustomersCustomerguidWorldpayCustomerIdGET: Partial<AxiosRequestConfig> | null;
export function getCustomersCustomerguidWorldpayCustomerIdGETRequestConfig() {
  return _requestConfigCustomersCustomerguidWorldpayCustomerIdGET;
}
export function setCustomersCustomerguidWorldpayCustomerIdGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCustomersCustomerguidWorldpayCustomerIdGET = value;
}
export function patchCustomersCustomerguidWorldpayCustomerIdGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCustomersCustomerguidWorldpayCustomerIdGET = patch(_requestConfigCustomersCustomerguidWorldpayCustomerIdGET ?? {});
}

let _requestConfigFormLeadsSubmitPOST: Partial<AxiosRequestConfig> | null;
export function getFormLeadsSubmitPOSTRequestConfig() {
  return _requestConfigFormLeadsSubmitPOST;
}
export function setFormLeadsSubmitPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigFormLeadsSubmitPOST = value;
}
export function patchFormLeadsSubmitPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigFormLeadsSubmitPOST = patch(_requestConfigFormLeadsSubmitPOST ?? {});
}

let _requestConfigListingsGuidGET: Partial<AxiosRequestConfig> | null;
export function getListingsGuidGETRequestConfig() {
  return _requestConfigListingsGuidGET;
}
export function setListingsGuidGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigListingsGuidGET = value;
}
export function patchListingsGuidGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigListingsGuidGET = patch(_requestConfigListingsGuidGET ?? {});
}

let _requestConfigListingsGuidCalendarDaysGET: Partial<AxiosRequestConfig> | null;
export function getListingsGuidCalendarDaysGETRequestConfig() {
  return _requestConfigListingsGuidCalendarDaysGET;
}
export function setListingsGuidCalendarDaysGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigListingsGuidCalendarDaysGET = value;
}
export function patchListingsGuidCalendarDaysGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigListingsGuidCalendarDaysGET = patch(_requestConfigListingsGuidCalendarDaysGET ?? {});
}

let _requestConfigListingsAvailablePOST: Partial<AxiosRequestConfig> | null;
export function getListingsAvailablePOSTRequestConfig() {
  return _requestConfigListingsAvailablePOST;
}
export function setListingsAvailablePOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigListingsAvailablePOST = value;
}
export function patchListingsAvailablePOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigListingsAvailablePOST = patch(_requestConfigListingsAvailablePOST ?? {});
}

let _requestConfigListingsGuidCalendarDayPricingsGET: Partial<AxiosRequestConfig> | null;
export function getListingsGuidCalendarDayPricingsGETRequestConfig() {
  return _requestConfigListingsGuidCalendarDayPricingsGET;
}
export function setListingsGuidCalendarDayPricingsGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigListingsGuidCalendarDayPricingsGET = value;
}
export function patchListingsGuidCalendarDayPricingsGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigListingsGuidCalendarDayPricingsGET = patch(_requestConfigListingsGuidCalendarDayPricingsGET ?? {});
}

let _requestConfigListingsAvailableListingsDetailsGET: Partial<AxiosRequestConfig> | null;
export function getListingsAvailableListingsDetailsGETRequestConfig() {
  return _requestConfigListingsAvailableListingsDetailsGET;
}
export function setListingsAvailableListingsDetailsGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigListingsAvailableListingsDetailsGET = value;
}
export function patchListingsAvailableListingsDetailsGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigListingsAvailableListingsDetailsGET = patch(_requestConfigListingsAvailableListingsDetailsGET ?? {});
}

let _requestConfigOwnersGuidGET: Partial<AxiosRequestConfig> | null;
export function getOwnersGuidGETRequestConfig() {
  return _requestConfigOwnersGuidGET;
}
export function setOwnersGuidGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigOwnersGuidGET = value;
}
export function patchOwnersGuidGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigOwnersGuidGET = patch(_requestConfigOwnersGuidGET ?? {});
}

let _requestConfigPaymentsCreatePaymentIntentPOST: Partial<AxiosRequestConfig> | null;
export function getPaymentsCreatePaymentIntentPOSTRequestConfig() {
  return _requestConfigPaymentsCreatePaymentIntentPOST;
}
export function setPaymentsCreatePaymentIntentPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsCreatePaymentIntentPOST = value;
}
export function patchPaymentsCreatePaymentIntentPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsCreatePaymentIntentPOST = patch(_requestConfigPaymentsCreatePaymentIntentPOST ?? {});
}

let _requestConfigPaymentsAuthorize_NetCreatePaymentPOST: Partial<AxiosRequestConfig> | null;
export function getPaymentsAuthorize_NetCreatePaymentPOSTRequestConfig() {
  return _requestConfigPaymentsAuthorize_NetCreatePaymentPOST;
}
export function setPaymentsAuthorize_NetCreatePaymentPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsAuthorize_NetCreatePaymentPOST = value;
}
export function patchPaymentsAuthorize_NetCreatePaymentPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsAuthorize_NetCreatePaymentPOST = patch(_requestConfigPaymentsAuthorize_NetCreatePaymentPOST ?? {});
}

let _requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOST: Partial<AxiosRequestConfig> | null;
export function getPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOSTRequestConfig() {
  return _requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOST;
}
export function setPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOST = value;
}
export function patchPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOST = patch(_requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentProcessPOST ?? {});
}

let _requestConfigPaymentsGuidGET: Partial<AxiosRequestConfig> | null;
export function getPaymentsGuidGETRequestConfig() {
  return _requestConfigPaymentsGuidGET;
}
export function setPaymentsGuidGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsGuidGET = value;
}
export function patchPaymentsGuidGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsGuidGET = patch(_requestConfigPaymentsGuidGET ?? {});
}

let _requestConfigPaymentsCreatePaymentSessionPOST: Partial<AxiosRequestConfig> | null;
export function getPaymentsCreatePaymentSessionPOSTRequestConfig() {
  return _requestConfigPaymentsCreatePaymentSessionPOST;
}
export function setPaymentsCreatePaymentSessionPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsCreatePaymentSessionPOST = value;
}
export function patchPaymentsCreatePaymentSessionPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsCreatePaymentSessionPOST = patch(_requestConfigPaymentsCreatePaymentSessionPOST ?? {});
}

let _requestConfigPaymentsCustomerDashboardCreatePaymentSessionPOST: Partial<AxiosRequestConfig> | null;
export function getPaymentsCustomerDashboardCreatePaymentSessionPOSTRequestConfig() {
  return _requestConfigPaymentsCustomerDashboardCreatePaymentSessionPOST;
}
export function setPaymentsCustomerDashboardCreatePaymentSessionPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsCustomerDashboardCreatePaymentSessionPOST = value;
}
export function patchPaymentsCustomerDashboardCreatePaymentSessionPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsCustomerDashboardCreatePaymentSessionPOST = patch(_requestConfigPaymentsCustomerDashboardCreatePaymentSessionPOST ?? {});
}

let _requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentPOST: Partial<AxiosRequestConfig> | null;
export function getPaymentsAuthorize_NetCheckoutSessionPaymentPOSTRequestConfig() {
  return _requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentPOST;
}
export function setPaymentsAuthorize_NetCheckoutSessionPaymentPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentPOST = value;
}
export function patchPaymentsAuthorize_NetCheckoutSessionPaymentPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentPOST = patch(_requestConfigPaymentsAuthorize_NetCheckoutSessionPaymentPOST ?? {});
}

let _requestConfigPaymentsAuthorize_NetCheckoutSessionGuidGET: Partial<AxiosRequestConfig> | null;
export function getPaymentsAuthorize_NetCheckoutSessionGuidGETRequestConfig() {
  return _requestConfigPaymentsAuthorize_NetCheckoutSessionGuidGET;
}
export function setPaymentsAuthorize_NetCheckoutSessionGuidGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsAuthorize_NetCheckoutSessionGuidGET = value;
}
export function patchPaymentsAuthorize_NetCheckoutSessionGuidGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsAuthorize_NetCheckoutSessionGuidGET = patch(_requestConfigPaymentsAuthorize_NetCheckoutSessionGuidGET ?? {});
}

let _requestConfigPaymentsStatusGET: Partial<AxiosRequestConfig> | null;
export function getPaymentsStatusGETRequestConfig() {
  return _requestConfigPaymentsStatusGET;
}
export function setPaymentsStatusGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsStatusGET = value;
}
export function patchPaymentsStatusGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsStatusGET = patch(_requestConfigPaymentsStatusGET ?? {});
}

let _requestConfigPaymentsWorldpayCheckoutSessionPaymentPOST: Partial<AxiosRequestConfig> | null;
export function getPaymentsWorldpayCheckoutSessionPaymentPOSTRequestConfig() {
  return _requestConfigPaymentsWorldpayCheckoutSessionPaymentPOST;
}
export function setPaymentsWorldpayCheckoutSessionPaymentPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsWorldpayCheckoutSessionPaymentPOST = value;
}
export function patchPaymentsWorldpayCheckoutSessionPaymentPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsWorldpayCheckoutSessionPaymentPOST = patch(_requestConfigPaymentsWorldpayCheckoutSessionPaymentPOST ?? {});
}

let _requestConfigPaymentsWorldpayCheckoutSessionPaymentProcessPOST: Partial<AxiosRequestConfig> | null;
export function getPaymentsWorldpayCheckoutSessionPaymentProcessPOSTRequestConfig() {
  return _requestConfigPaymentsWorldpayCheckoutSessionPaymentProcessPOST;
}
export function setPaymentsWorldpayCheckoutSessionPaymentProcessPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsWorldpayCheckoutSessionPaymentProcessPOST = value;
}
export function patchPaymentsWorldpayCheckoutSessionPaymentProcessPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsWorldpayCheckoutSessionPaymentProcessPOST = patch(_requestConfigPaymentsWorldpayCheckoutSessionPaymentProcessPOST ?? {});
}

let _requestConfigPaymentsWorldpayCheckoutSessionGuidGET: Partial<AxiosRequestConfig> | null;
export function getPaymentsWorldpayCheckoutSessionGuidGETRequestConfig() {
  return _requestConfigPaymentsWorldpayCheckoutSessionGuidGET;
}
export function setPaymentsWorldpayCheckoutSessionGuidGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsWorldpayCheckoutSessionGuidGET = value;
}
export function patchPaymentsWorldpayCheckoutSessionGuidGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsWorldpayCheckoutSessionGuidGET = patch(_requestConfigPaymentsWorldpayCheckoutSessionGuidGET ?? {});
}

let _requestConfigPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST: Partial<AxiosRequestConfig> | null;
export function getPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOSTRequestConfig() {
  return _requestConfigPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST;
}
export function setPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST = value;
}
export function patchPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST = patch(_requestConfigPaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST ?? {});
}

let _requestConfigPaymentsIntent__DebugPOST: Partial<AxiosRequestConfig> | null;
export function getPaymentsIntent__DebugPOSTRequestConfig() {
  return _requestConfigPaymentsIntent__DebugPOST;
}
export function setPaymentsIntent__DebugPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsIntent__DebugPOST = value;
}
export function patchPaymentsIntent__DebugPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsIntent__DebugPOST = patch(_requestConfigPaymentsIntent__DebugPOST ?? {});
}

let _requestConfigPaymentsCheckoutSession__DebugPOST: Partial<AxiosRequestConfig> | null;
export function getPaymentsCheckoutSession__DebugPOSTRequestConfig() {
  return _requestConfigPaymentsCheckoutSession__DebugPOST;
}
export function setPaymentsCheckoutSession__DebugPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsCheckoutSession__DebugPOST = value;
}
export function patchPaymentsCheckoutSession__DebugPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPaymentsCheckoutSession__DebugPOST = patch(_requestConfigPaymentsCheckoutSession__DebugPOST ?? {});
}

let _requestConfigPlatformAccountPaymentGatewayGET: Partial<AxiosRequestConfig> | null;
export function getPlatformAccountPaymentGatewayGETRequestConfig() {
  return _requestConfigPlatformAccountPaymentGatewayGET;
}
export function setPlatformAccountPaymentGatewayGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPlatformAccountPaymentGatewayGET = value;
}
export function patchPlatformAccountPaymentGatewayGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPlatformAccountPaymentGatewayGET = patch(_requestConfigPlatformAccountPaymentGatewayGET ?? {});
}

let _requestConfigPricingsCalculateGET: Partial<AxiosRequestConfig> | null;
export function getPricingsCalculateGETRequestConfig() {
  return _requestConfigPricingsCalculateGET;
}
export function setPricingsCalculateGETRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPricingsCalculateGET = value;
}
export function patchPricingsCalculateGETRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPricingsCalculateGET = patch(_requestConfigPricingsCalculateGET ?? {});
}

let _requestConfigPricingsGuidPromoCodeValidationPOST: Partial<AxiosRequestConfig> | null;
export function getPricingsGuidPromoCodeValidationPOSTRequestConfig() {
  return _requestConfigPricingsGuidPromoCodeValidationPOST;
}
export function setPricingsGuidPromoCodeValidationPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPricingsGuidPromoCodeValidationPOST = value;
}
export function patchPricingsGuidPromoCodeValidationPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPricingsGuidPromoCodeValidationPOST = patch(_requestConfigPricingsGuidPromoCodeValidationPOST ?? {});
}

let _requestConfigPricingsGuidCampaignValidationPOST: Partial<AxiosRequestConfig> | null;
export function getPricingsGuidCampaignValidationPOSTRequestConfig() {
  return _requestConfigPricingsGuidCampaignValidationPOST;
}
export function setPricingsGuidCampaignValidationPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPricingsGuidCampaignValidationPOST = value;
}
export function patchPricingsGuidCampaignValidationPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPricingsGuidCampaignValidationPOST = patch(_requestConfigPricingsGuidCampaignValidationPOST ?? {});
}

let _requestConfigPricingsGuidCampaignValidationByCustomerEmailPOST: Partial<AxiosRequestConfig> | null;
export function getPricingsGuidCampaignValidationByCustomerEmailPOSTRequestConfig() {
  return _requestConfigPricingsGuidCampaignValidationByCustomerEmailPOST;
}
export function setPricingsGuidCampaignValidationByCustomerEmailPOSTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPricingsGuidCampaignValidationByCustomerEmailPOST = value;
}
export function patchPricingsGuidCampaignValidationByCustomerEmailPOSTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPricingsGuidCampaignValidationByCustomerEmailPOST = patch(_requestConfigPricingsGuidCampaignValidationByCustomerEmailPOST ?? {});
}

let _requestConfigTestTestSentryPUT: Partial<AxiosRequestConfig> | null;
export function getTestTestSentryPUTRequestConfig() {
  return _requestConfigTestTestSentryPUT;
}
export function setTestTestSentryPUTRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTestTestSentryPUT = value;
}
export function patchTestTestSentryPUTRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTestTestSentryPUT = patch(_requestConfigTestTestSentryPUT ?? {});
}